<template>
  <el-select 
    :value="value" 
    @change="change"
    :disabled="disabled"
    :size="size"
    :clearable="clearable"
    :placeholder="placeholder" 
    :filterable='filterable'
    :remote="remote"
    :multiple="multiple"
    :remote-method="remoteMethod"
    :loading="loading"
    :class='className'>
    <el-option
      v-for="item in dataList"
      :key="item[propKey.key]"
      :label="item[propKey.label]"
      :value="item[propKey.value]">
    </el-option>
  </el-select>
</template>

<script type="text/javascript">
export default {
  props: {
    className:{
      type:String,
      default:'width100'
    },
    size:{
      type:String,
      default:'medium'
    },
    placeholder:{
      type:String,
      default:'请选择'
    },
    dataList:{
      type:Array,
      default:function(){
        return []
      }
    },
    propKey:{
      type:Object,
      default:function() {
        return {
          key:'value',
          value:'value',
          label:'label'
        };
      }
    },
    disabled:{
      type:Boolean,
      default:false
    },
    value:{
      default:null
    },
    clearable:{
      type:Boolean,
      default:true
    },
    filterable:{
      type:Boolean,
      default:false
    },
    remote:{
      type:Boolean,
      default:false
    },
    multiple:{
      type:Boolean,
      default:false
    },
  },
  model:{
    prop:'value',
    event:'change'
  },
  data(){
    return {
      loading:false
    }
  },
  methods: {
    change(value){
      this.$emit('change',value)
    },
    remoteMethod(query){
      this.loading=true
      this.$emit('getList',query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/defaultSelect.vue